import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { VariablesGlobalesService } from "../variables-globales.service";
import { AMRespuestaGET } from "src/app/Models/RespuestaGET/AMRespuestaGET";
import { Observable } from "rxjs";
import { enumTipoMovimientoTesoreria, globalConf } from "src/GlobalConf";
import { AlbaranDTO, EstadoEntidadAsignacionDTO, FacturaDTO, FacturaSimplificadaDTO, MovimientoTesoreriaDTO, PedidoDTO, PresupuestoDTO } from "src/app/Models/ApiV2/DocumentoDTO";
import { AMRespuestaPOSTPUT } from "src/app/Models/RespuestaPOSTPUT/AMRespuestaPOSTPUT";

@Injectable({
  providedIn: 'root'
})
export class DocumentosErpService {
  private http = inject(HttpClient);
  variablesGlobales = inject(VariablesGlobalesService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() { }


  /**
   * METDOS GETS
   */

  /**
  * Método para realizar la petición a ALO solicitanto la lista de series de documentos de una empresa
  * @param listaParametros filtros para aplicar en la petición para obtener la lista de series
  * @returns Lista de series que devuelve ALO
  */
  obtenerSeriesAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/series', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de pedidos de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de pedidos de venta
* @returns Lista de pedidos que devuelve ALO
*/
  obtenerPedidosVentaAlo(listaParametros?): Observable<AMRespuestaGET> {
    console.log("listaParámetros peticion " , listaParametros)
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/pedidos/venta', { params: listaParametros })
  }
    /**
* Método para realizar la petición a ALO solicitanto la lista de pedidos de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de pedidos de venta
* @returns Lista de pedidos que devuelve ALO
*/
obtenerPedidosCompraAlo(listaParametros?): Observable<AMRespuestaGET> {
  return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/pedidos/compra', { params: listaParametros })
}

  /**
* Método para realizar la petición a ALO solicitanto la lista de facturas de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de facturas de venta
* @returns Lista de facturas que devuelve ALO
*/
  obtenerFacturasVentaAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturas/venta', { params: listaParametros })
  }
  /**
* Método para realizar la petición a ALO solicitanto la lista de facturas de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de facturas de venta
* @returns Lista de facturas que devuelve ALO
*/
obtenerFacturasCompraAlo(listaParametros?): Observable<AMRespuestaGET> {
  return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturas/compra', { params: listaParametros })
}

  /**
* Método para realizar la petición a ALO solicitanto la lista de facturas de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de facturas de venta
* @returns Lista de facturas que devuelve ALO
*/
obtenerFacturasSimplificadasAlo(listaParametros?): Observable<AMRespuestaGET> {
  return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturassimplificadas', { params: listaParametros })
}


  /**
* Método para realizar la petición a ALO solicitanto la lista de albaranes de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de albaranes de venta
* @returns Lista de albaranes que devuelve ALO
*/
  obtenerAlbaranesVentaAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/albaranes/venta', { params: listaParametros })
  }

      /**
  * Método para realizar la petición a ALO solicitanto la lista de albaranes de venta de una empresa
  * @param listaParametros filtros para aplicar en la petición para obtener la lista de albaranes de venta
  * @returns Lista de albaranes que devuelve ALO
  */
  obtenerAlbaranesCompraAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/albaranes/compra', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de presupuestos de venta de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de presupuestos de venta
* @returns Lista de presupuestos que devuelve ALO
*/
  obtenerPresupuestosAlo(listaParametros?): Observable<AMRespuestaGET> {
    return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/presupuestos', { params: listaParametros })
  }

  /**
* Método para realizar la petición a ALO solicitanto la lista de moviminetos de tesoreia de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de moviminetos de tesoreia
* @returns Lista de movimientos de tesoreia que devuelve ALO
*/
obtenerMovimientosTesoreriaAlo(tipo:string, listaParametros?): Observable<AMRespuestaGET> {
  return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/movimientostesoreria/'+tipo+'/', { params: listaParametros })
}

  /**
* Método para realizar la petición a ALO solicitanto la lista de vencimientos de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de vencimientos
* @returns Lista de vencimientos que devuelve ALO
*/
obtenerVencimientosAlo(tipo:string, listaParametros?): Observable<AMRespuestaGET> {
  return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/vencimientos/'+tipo+'/', { params: listaParametros })
}

  /**
* Método para realizar la petición a ALO solicitanto la lista de estados de pedidos de una empresa
* @param listaParametros filtros para aplicar en la petición para obtener la lista de estados de pedido
* @returns Lista de estados de pedidos que devuelve ALO
*/
obtenerEstadosPedidoAlo(tipoOperacion:string, listaParametros?): Observable<AMRespuestaGET> {
  return this.http.get<AMRespuestaGET>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/estados/pedidos/'+tipoOperacion+'/', { params: listaParametros })
}

  /**
  * METDOS POST PUT
  */

  /**
  * Método para realizar la petición a ALO para grabar un pedido de venta
  * @param pedidoAlo PedidoDTO
  */
  postPutPedidosVenta(pedidoAlo: PedidoDTO): Observable<AMRespuestaPOSTPUT> {
    var pedidosAloJSON = [];
    pedidosAloJSON.push(pedidoAlo)
    if (pedidoAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/pedidos/venta', pedidosAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/pedidos/venta', pedidosAloJSON)
    }

  }

  /**
  * Método para realizar la petición a ALO para grabar un pedido de compra
  * @param pedidoAlo PedidoDTO
  */
  postPutPedidosCompra(pedidoAlo: PedidoDTO): Observable<AMRespuestaPOSTPUT> {
    var pedidosAloJSON = [];
    pedidosAloJSON.push(pedidoAlo)
    if (pedidoAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/pedidos/compra', pedidosAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/pedidos/compra', pedidosAloJSON)
    }

  }

  /**
  * Método para realizar la petición a ALO para grabar una factura de venta
  * @param facturaAlo FacturaDTO
  */
  postPutFacturasVenta(facturaAlo: FacturaDTO): Observable<AMRespuestaPOSTPUT> {
    var facturasAloJSON = [];
    facturasAloJSON.push(facturaAlo)
    if (facturaAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturas/venta', facturasAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturas/venta', facturasAloJSON)
    }

  }

  /**
  * Método para realizar la petición a ALO para grabar una factura de compra
  * @param facturaAlo FacturaDTO
  */
  postPutFacturasCompra(facturaAlo: FacturaDTO): Observable<AMRespuestaPOSTPUT> {
    var facturasAloJSON = [];
    facturasAloJSON.push(facturaAlo)
    if (facturaAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturas/compra', facturasAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturas/compra', facturasAloJSON)
    }

  }

  /**
  * Método para realizar la petición a ALO para grabar una factura simplificada
  * @param facturaAlo FacturaDTO
  */
  postPutFacturasSimplificada(facturaSimplificadasAlo: FacturaSimplificadaDTO): Observable<AMRespuestaPOSTPUT> {
    var facturasSimplificadasAloJSON = [];
    facturasSimplificadasAloJSON.push(facturaSimplificadasAlo)
    if (facturaSimplificadasAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturassimplificadas/venta', facturasSimplificadasAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/facturassimplificadas/venta', facturasSimplificadasAloJSON)
    }

  }

  /**
* Método para realizar la petición a ALO para grabar un albarán de venta
* @param albaranAlo AlbaranDTO
*/
  postPutAlbaranesVenta(albaranAlo: AlbaranDTO): Observable<AMRespuestaPOSTPUT> {
    var albaranesAloJSON = [];
    albaranesAloJSON.push(albaranAlo)
    console.log({ albaranesAloJSON });
    if (albaranAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/albaranes/venta', albaranesAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/albaranes/venta', albaranesAloJSON)
    }

  }

    /**
* Método para realizar la petición a ALO para grabar un albarán de compra
* @param albaranAlo AlbaranDTO
*/
postPutAlbaranesCompra(albaranAlo: AlbaranDTO): Observable<AMRespuestaPOSTPUT> {
  var albaranesAloJSON = [];
  albaranesAloJSON.push(albaranAlo)
  console.log({ albaranesAloJSON });
  if (albaranAlo.id) {
    return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/albaranes/compra', albaranesAloJSON)
  } else {
    return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/albaranes/compra', albaranesAloJSON)
  }

}

  postPutPresupuestos(presupuestoAlo: PresupuestoDTO): Observable<AMRespuestaPOSTPUT> {
    var presupuestosAloJSON = [];
    presupuestosAloJSON.push(presupuestoAlo)
    console.log({ presupuestosAloJSON });
    if (presupuestoAlo.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/presupuestos', presupuestosAloJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/presupuestos', presupuestosAloJSON)
    }

  }

  /**
* Método para realizar la petición a ALO para grabar un movimiento de tesorería
* @param movimientoTesoreria MovimientoTesoreriaDTO
*/
  postPutMovimientoTesoreria(movimientoTesoreria: MovimientoTesoreriaDTO, tipo: enumTipoMovimientoTesoreria): Observable<AMRespuestaPOSTPUT> {
    var movimientosTesoreriaJSON = [];
    movimientosTesoreriaJSON.push(movimientoTesoreria)
    if (movimientoTesoreria.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/movimientostesoreria/' + tipo, movimientosTesoreriaJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/movimientostesoreria/' + tipo, movimientosTesoreriaJSON)
    }

  }
    /**
* Método para realizar la petición a ALO para grabar o actualizar el estado de los pedidos
* @param estadoEntidadAsignacionDTO estadoEntidadAsignacionDTO
*/
  postPutEstadosPedidos(estadoPedido: EstadoEntidadAsignacionDTO): Observable<AMRespuestaPOSTPUT> {
    var estadosPedidosJSON = [];
    estadosPedidosJSON.push(estadoPedido)
    console.log({estadosPedidosJSON});
    if (estadoPedido.id) {
      return this.http.put<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/estadospedidos/', estadosPedidosJSON)
    } else {
      return this.http.post<AMRespuestaPOSTPUT>(globalConf.url_api_erp + 'api/v2/documentos/' + this.variablesGlobales.empresaActual.GUID_Registro + '/estadospedidos/', estadosPedidosJSON)
    }
  }

}